import { cn } from "./_utils";

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean;
};

/**
 * Form label. When `required`, appends a red asterisk.
 *
 * @example
 * <Label htmlFor="email">Email</Label>
 * <Label htmlFor="email" required>Email</Label>
 */
export function Label({
  className,
  required,
  children,
  ...props
}: LabelProps) {
  return (
    <label
      className={cn("text-sm font-medium text-text-primary", className)}
      {...props}
    >
      {children}
      {required && (
        <span className="text-error ml-2xs" aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
}
